"use client";

import { useMakeupsEligibilitySettings } from "./useMakeupsEligibilitySettings";

type UseMakeupsExpiryInDaysOptions = {
  enabled?: boolean;
};

export function useMakeupsExpiryInDays({
  enabled = true,
}: UseMakeupsExpiryInDaysOptions = {}) {
  const settings = useMakeupsEligibilitySettings({ enabled });

  return {
    expiryDays: settings.expiryDays,
    persisted: settings.persisted.expiry,
    isPending: settings.isPending,
    isFetching: settings.isFetching,
    isError: settings.isError,
    refetch: settings.refetch,
  };
}

export { useMakeupsEligibilitySettingsUpdate as useMakeupsExpiryInDaysUpdate } from "./useMakeupsEligibilitySettings";
